/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import {
  SHOPPING_PRIMARY_CATEGORY,
  CHANNEL_TAG_SLUG_SHOPPING
} from '../constants';
import Article from '../components/article';
import OutOfPageAd from '../components/ad/out_of_page_ad';
import { changeSlide } from '../actions/slide';
import { pickBridgeRecommendation } from '../actions/up_next';
import { envSpecificSpotID } from '../utils/env';
import { addEditorialLinkClickTrackers } from '../utils/analytics';
import {get, trim, isEmpty} from 'lodash';

const options = {
  displayName: 'ArticleContainer',

  propTypes: {
    article: PropTypes.object.isRequired,
    changeSlide: PropTypes.func.isRequired,
    isInitialPageview: PropTypes.bool.isRequired,
    newsletters: PropTypes.array.isRequired,
    pickBridgeRecommendation: PropTypes.func.isRequired,
    upNext: PropTypes.object.isRequired
  },

  mapDispatchToProps: {
    changeSlide,
    pickBridgeRecommendation
  },

  mapStateToProps: (state) => [
    state,
    {
      article: state.article,
      isInitialPageview: state.api.isInitialPageview,
      upNext: state.upNext
    }
  ],

  componentDidMount() {
    addEditorialLinkClickTrackers();
  },

  componentDidUpdate() {
    addEditorialLinkClickTrackers();
  },

  article() {
    return (
      <Article
        {...this.props.article}
        adsState={this.props.adsState}
        changeSlide={this.props.changeSlide}
        channels={this.props.analytics.channels}
        isInitialPageview={this.props.isInitialPageview}
        isShoppingArticle={this.isShoppingArticle()}
        meta_title={this.props.meta_data.meta_title}
        meta_description={this.props.meta_data.meta_description}
        newsletters={this.props.newsletters}
        pickBridgeRecommendation={this.props.pickBridgeRecommendation}
        spotID={this.spotID()}
        upNext={this.props.upNext}
        url_full={this.props.analytics.url_full}
        geolocation={this.props.geolocation}
      />
    );
  },

  contentAboveModules() {
    if (isEmpty(this.props.article)) {
      return null;
    }
    return this.article();
  },

  contentBelowModules() {
    const { article } = this.props;
    return !isEmpty(article) && trim(get(this.props, 'adsState.ad_data.ad_sponsorship', '')).length > 0 ? (
      <>
        <OutOfPageAd adsState={this.props.adsState} position="1x1"/>
        <OutOfPageAd adsState={this.props.adsState} position="1x1" breakPoint="mobile" uniqueId="out-of-page-mobile"/>
      </>
    ) : null;
  },

  isShoppingArticle() {
    const section_name = get(this.props, 'adsState.ad_data.ad_section_name');
    return section_name
      ? section_name.includes(CHANNEL_TAG_SLUG_SHOPPING)
      : false;
  },

  isShoppingVertical() {
    return (
      get(this.props, 'article.primary_category.name') ===
      SHOPPING_PRIMARY_CATEGORY
    );
  },

  shouldDisplayAdhesionAd() {
    return (
      !this.isShoppingVertical() &&
      isEmpty(get(this.props, 'adsState.ad_data.ad_sponsorship'))
    );
  },

  spotID() {
    return envSpecificSpotID(
      this.props.location.hostname,
      this.props.edition_data.config.spotim_id
    );
  }
};

export const ArticleContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
